import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './js/globals.js'

createApp(App).use(router).mount('#app')
